/**
 * @author Ashish Dwivedi <ashish.dwivedi@314ecorp.com>
 * @description React Hook useExportEligibilityBatchTemplate
 */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import _ from 'lodash';

import api from 'client/index';
import AppEvents, { Events, Messages } from '@veritable/common/utils/appEvents';
import { downloadBlobFile } from '@veritable/common/utils';

/**
 * Mutate to export eligibility batch template
 */
const useExportEligibilityBatchTemplate = (): UseMutationResult<unknown, IAxiosError, unknown, unknown> => {
	return useMutation({
		mutationFn: async () => {
			const { data } = await api.EzapiApi.getBatchUploadEligibilityRequestTemplate({
				responseType: 'blob',
			});

			downloadBlobFile(
				data,
				_.kebabCase('eligibility-batch-upload-template'),
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'download',
			);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
		},
		onMutate: () => {
			AppEvents.publish(Events.Loading, Messages.DownloadingFile);
		},
		onError: (error) => {
			const fileReader = new FileReader();
			fileReader.addEventListener('loadend', () => {
				const parsedError = { response: { data: JSON.parse(fileReader.result as string) } } as IAxiosError;
				AppEvents.publishApiError({ error: parsedError });
			});
			fileReader.readAsText(error.response?.data as unknown as AnyType);
		},
	});
};

export default useExportEligibilityBatchTemplate;
